/* Design Tokens — תורגמו מהאתר הקיים (public_html) ומהווים את ה-Source of Truth
   לזהות הוויזואלית של המערכת. כל שינוי עיצוב רוחבי מתבצע כאן בלבד. */
import type { MantineColorsTuple } from '@mantine/core';

/* ---------- פלטת המותג ---------- */
/* האתר בנוי על שחור-אפור מונוכרומטי. גוון 6 הוא ה-primary בפועל
   (--gold:#e9e9e9 במקור, למרות השם ההיסטורי הוא אפור-בהיר). */
export const brandColors: MantineColorsTuple = [
  '#f7f7f7',
  '#eeeeee',
  '#e9e9e9',
  '#d6d6d6',
  '#c4c4c4',
  '#b4b4b4',
  '#e9e9e9',
  '#8a8a8a',
  '#2a2a2a',
  '#1c1c1c',
];

/* גווני הבסיס הכהים — הרקע והמשטחים של האתר */
export const darkColors: MantineColorsTuple = [
  '#d3d7de',
  '#a6abb5',
  '#8a8a8a',
  '#6f7580',
  '#2a2a2a',
  '#1c1c1c',
  '#111111',
  '#0a0a0a',
  '#04060a',
  '#000000',
];

/* ---------- צבעים סמנטיים ---------- */
/* שתי ערכות: dark = ברירת המחדל (בית, מחלקות, אודות),
   glass = הווריאנט הכחלחל של עמודי המחלקות. */
export const palette = {
  dark: {
    black: '#000000',
    ink: '#0a0a0a',
    panel: '#111111',
    line: '#2a2a2a',
    lineSoft: '#1c1c1c',
    fog: '#8a8a8a',
    mute: '#b4b4b4',
    silver: '#d6d6d6',
    white: '#ffffff',
    accent: '#e9e9e9',
    accentSoft: '#c4c4c4',
  },
  glass: {
    black: '#000000',
    deep: '#04060a',
    glass: '#0b0f16',
    line: '#1a1f28',
    lineSoft: '#12161d',
    fog: '#6f7580',
    mute: '#a6abb5',
    silver: '#d3d7de',
    white: '#ffffff',
    accent: '#e9e9e9',
    accentSoft: '#c4c4c4',
  },
} as const;

/* ---------- טיפוגרפיה ---------- */
export const typography = {
  fontFamily: 'Heebo, sans-serif',
  fontFamilySerif: 'Assistant, sans-serif',
  /* clamp() מהמקור — הכותרות מתכווצות ברוחב מסך קטן */
  h1: 'clamp(38px, 6vw, 78px)',
  h2: 'clamp(34px, 5.5vw, 68px)',
  h3: 'clamp(24px, 3vw, 34px)',
  lead: 'clamp(15px, 1.7vw, 18px)',
  heroLine: 'clamp(13px, 1.5vw, 17px)',
  kicker: '13px',
  body: '17px',
  small: '14px',
} as const;

/* ---------- פריסה ותנועה ---------- */
export const layout = {
  maxWidth: '1180px',
  maxWidthNarrow: '1140px',
  maxWidthText: '820px',
  navHeight: '72px',
  sectionPad: '130px',
  wrapPad: '40px',
} as const;

export const motion = {
  ease: 'cubic-bezier(.22,.61,.36,1)',
  fast: '.3s',
  base: '.55s',
  slow: '.9s',
} as const;

export const radii = {
  xs: '4px',
  sm: '8px',
  md: '12px',
  lg: '18px',
  pill: '999px',
} as const;
